// extracted by mini-css-extract-plugin
export default {"tableQuickFiltersSectionHeader":"tableQuickFiltersSectionHeader--KvVGn"};